/// <reference path="../nativewind-augmentation.d.ts" />
// Copyright (c) Ping. All rights reserved.
//
// Two-button segmented control matching Figma file
// gtBsWqJJcI6ZBuBv51RU35 node 3281:98445 (horizontal tabs).
//
//   container : 400 × 52, padding 4, bg `surface-panel`, radius 16
//   tab       : 192 × 44, radius 12
//   inactive  : transparent, text `text-secondary` (Lato 700 / 16 / 22)
//   active    : bg `surface-elevated`, text `text-primary`

import { Pressable, Text, View } from 'react-native';

export interface AuthTabsOption<T extends string> {
	readonly value: T;
	readonly label: string;
}

export interface AuthTabsProps<T extends string> {
	readonly value: T;
	readonly options: readonly AuthTabsOption<T>[];
	readonly onChange: (next: T) => void;
}

export function AuthTabs<T extends string>({
	value,
	options,
	onChange,
}: AuthTabsProps<T>): JSX.Element {
	return (
		<View
			accessibilityRole="tablist"
			className="flex-row items-center w-[400px] h-[52px] rounded-[16px] p-xs bg-light-surface-panel dark:bg-dark-surface-panel"
		>
			{options.map((option) => {
				const isActive = option.value === value;
				return (
					<Pressable
						key={option.value}
						accessibilityRole="tab"
						accessibilityState={{ selected: isActive }}
						accessibilityLabel={`ping_auth_tab_${option.value}`}
						onPress={() => onChange(option.value)}
						className={`flex-1 h-[44px] rounded-[12px] items-center justify-center ${
							isActive
								? 'bg-light-surface-elevated dark:bg-dark-surface-elevated'
								: 'bg-transparent'
						}`}
					>
						<Text
							className={`font-sans font-bold text-[16px] leading-[22px] ${
								isActive
									? 'text-light-text-primary dark:text-dark-text-primary'
									: 'text-light-text-muted dark:text-dark-text-muted'
							}`}
						>
							{option.label}
						</Text>
					</Pressable>
				);
			})}
		</View>
	);
}
